import { CATEGORY_LABELS, MARKET_LABELS, type Signal } from "@shared/schema/signal";
import { formatChange, formatTime } from "../lib";
import { Sparkline } from "./Sparkline";

function Stat({ label, value }: { label: string; value: string }) {
  return <div className="detail-stat"><span>{label}</span><strong>{value}</strong></div>;
}

export function SignalDetail({ signal }: { signal: Signal }) {
  return (
    <div className="signal-detail">
      <p className="detail-description">{signal.description}</p>
      <div className="detail-grid">
        <Stat label="当前值" value={signal.displayValue} />
        <Stat label={signal.frequency === "monthly" ? "较上月" : "1 期"} value={formatChange(signal.change1d)} />
        <Stat label="5 期" value={formatChange(signal.change5d)} />
        <Stat label="30D 分位" value={signal.percentile30d === undefined ? "—" : `${signal.percentile30d.toFixed(0)}%`} />
        <Stat label="1Y 分位" value={signal.percentile1y === undefined ? "—" : `${signal.percentile1y.toFixed(0)}%`} />
        <Stat label="连续变化" value={signal.persistence ? `${signal.persistence} 期` : "—"} />
      </div>
      <div className="detail-history">
        <div><span>历史走势</span><small>{signal.history.length} 个观测</small></div>
        <Sparkline values={signal.history.map((point) => point.value)} direction={signal.direction} width={420} height={72} />
      </div>
      <div className="detail-source">
        <div><span>市场 / 分类</span><strong>{MARKET_LABELS[signal.market]} · {CATEGORY_LABELS[signal.category]}</strong></div>
        <div><span>数据来源</span><strong>{signal.source.url ? <a href={signal.source.url} target="_blank" rel="noreferrer">{signal.source.name}</a> : signal.source.name}</strong></div>
        <div><span>数据时间</span><strong>{formatTime(signal.timestamp)}</strong></div>
        <div><span>采集状态</span><strong className={`status-${signal.status}`}>{signal.status === "fresh" ? "已更新" : signal.status === "stale" ? "数据已过期" : "暂不可用"}</strong></div>
      </div>
    </div>
  );
}
